import { render, staticRenderFns } from "./NotificationIcon.vue?vue&type=template&id=5345e83c"
import script from "./NotificationIcon.vue?vue&type=script&lang=js"
export * from "./NotificationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports